module.exports = __webpack_public_path__ + "img/member-leaf.a12d205.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/console/member-leaf.png
// module id = UXs9
// module chunks = 7 40 60